var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCorrelation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.25 4.25v15.5h15.5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 16,
    r: 1.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.3,
    cy: 12.8,
    r: 1.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.7,
    cy: 9.5,
    r: 1.05
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.2,
    cy: 6.4,
    r: 1.05
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrelation);
export default __webpack_public_path__ + "static/media/correlation.b4f96e09b7f871678a09b2b2cbdf4964.svg";
export { ForwardRef as ReactComponent };